import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SgzpApp5ChangePasswordSentComponent } from './sgzp-app5-change-password-sent/sgzp-app5-change-password-sent.component';
import { SgzpApp5ForgotPasswordComponent } from './sgzp-app5-forgot-password/sgzp-app5-forgot-password.component';
import { SgzpApp5InputComponent } from './sgzp-app5-input/sgzp-app5-input.component';
import { SgzpApp5LoginComponent } from './sgzp-app5-login/sgzp-app5-login.component';
import { SgzpApp5PasswordInputComponent } from './sgzp-app5-password-input/sgzp-app5-password-input.component';
import { SgzpApp5RegisterResendComponent } from './sgzp-app5-register-resend/sgzp-app5-register-resend.component';
import { SgzpApp5RegisterSendComponent } from './sgzp-app5-register-send/sgzp-app5-register-send.component';
import { SgzpApp5RegisterComponent } from './sgzp-app5-register/sgzp-app5-register.component';
import { SgzpApp5ResetPasswordComponent } from './sgzp-app5-reset-password/sgzp-app5-reset-password.component';
import { SgzpApp5UnblockComponent } from './sgzp-app5-unblock/sgzp-app5-unblock.component';
import { SgzpApp5Component } from './sgzp-app5/sgzp-app5.component';

@NgModule({
  declarations: [
    SgzpApp5Component,
    SgzpApp5LoginComponent,
    SgzpApp5RegisterComponent,
    SgzpApp5UnblockComponent,
    SgzpApp5RegisterResendComponent,
    SgzpApp5RegisterSendComponent,
    SgzpApp5ForgotPasswordComponent,
    SgzpApp5ResetPasswordComponent,
    SgzpApp5ChangePasswordSentComponent,
    SgzpApp5InputComponent,
    SgzpApp5PasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SgzpApp5ResetPasswordComponent,
    SgzpApp5Component,
    SgzpApp5RegisterResendComponent,
    SgzpApp5RegisterSendComponent,
    SgzpApp5UnblockComponent,
    SgzpApp5ChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SgzpApp5Module {}
